import { object, ref, string } from "yup";
// @ts-expect-error pure js
import { stringMax } from "./utils";
import {
  EMAIL_INVALID_MESSAGE,
  EMAIL_REGEX,
  passwordSchema,
} from "../utils/constants/validation";

export interface SignUpInfosValues {
  pro: string;
  home: string;
  prenom: string;
  nom: string;
  telephone: string;
  recommandation: string;
  precision_reco: string;
  motivation: string;
}

export interface SignUpValues extends SignUpInfosValues {
  mail: string;
  password: string;
  dPassword: string;
}

export const signUpInfosInitialValues: SignUpInfosValues = {
  pro: "/bailleur",
  home: "",
  prenom: "",
  nom: "",
  telephone: "",
  recommandation: "",
  precision_reco: "",
  motivation: "",
};

export const signUpInitialValues: SignUpValues = {
  ...signUpInfosInitialValues,
  mail: "",
  password: "",
  dPassword: "",
};

export const signUpProInitialValues: SignUpValues = {
  ...signUpInitialValues,
  home: "/pro",
  pro: "/pro",
};

export const signUpInfosSchema = object({
  home: string()
    .oneOf(["/bailleur", "/locataire", "/pro"], "Choisissez votre profil")
    .required("Choisissez votre profil"),
  motivation: stringMax(250).when("home", {
    is: "/bailleur",
    then: stringMax(250).required("Choisissez une réponse"),
    otherwise: stringMax(250).notRequired(),
  }),
  telephone: stringMax(250).when(["home", "pro"], {
    is: (home: string, pro: string) => home === "/bailleur" || pro === "/pro",
    then: stringMax(250).required("Numéro de téléphone requis"),
    otherwise: stringMax(250).notRequired(),
  }),
  pro: string().required(""),
  prenom: stringMax(250).notRequired(),
  nom: stringMax(250).notRequired(),
  recommandation: stringMax(250).when(["home", "pro"], {
    is: (home: string, pro: string) => home === "/bailleur" || pro === "/pro",
    then: stringMax(250).required("Recommandation requise"),
    otherwise: stringMax(250).notRequired(),
  }),
  precision_reco: stringMax(250).when(["home", "recommandation", "pro"], {
    is: (home: string, recommandation: string, pro: string) =>
      (home === "/bailleur" || pro === "/pro") &&
      (recommandation === "PODCAST" || recommandation === "AUTRES"),
    then: stringMax(250).required("Précisez la recommandation"),
    otherwise: stringMax(250).notRequired(),
  }),
});

export const signUpSchema = signUpInfosSchema.concat(
  object({
    mail: string()
      .matches(EMAIL_REGEX, EMAIL_INVALID_MESSAGE)
      .required("Adresse e-mail requise"),
    password: passwordSchema().required("Mot de passe requis"),
    dPassword: string()
      .oneOf([ref("password")], "Les mots de passe doivent être identiques")
      .required("Confirmation requise"),
  }),
);
